import { Edge, NETWORK_TYPE } from '~/types/Edge';
import { authenticationService } from './authentication-service';
import { EdgeRelease } from '~/types/SoftwareReleases';

export const edgeService = {
    getEdges,
    getEdgePool,
    getEdgeReleases,
    updateEdgeERelease,
    deleteEdgeRelease,
};

async function getEdges(filter ?:any) {
    const requestBody = filter || {"filter" :{}}
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
        body : JSON.stringify(requestBody)
    };

    const res = await fetch(`/api/v1/saas/edges/query`, requestOptions);
    const result = await res.json();
    return result.data as Edge[]
}
async function getEdgePool(filter : any) {
    const requestBody = filter || {"filter" :{}}
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',  
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
        body : JSON.stringify(requestBody)
    };

    const res = await fetch(`/api/v1/saas/edgePools/query`, requestOptions);
    const result = await res.json();
    return result.data as any[]
}


async function getEdgeReleases(requestBody ?: {
    filter: {
        networkType?: NETWORK_TYPE,
        edgeLocationType?: string,
        locationType?: string,
        tenantId?: string,
        vmcRelease?: string,
    }
}, signal?: AbortSignal){
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
        body : JSON.stringify(requestBody),
        signal
    };

    const res = await fetch(`api/v1/saas/edges/releases/query`, requestOptions);
    const result = await res.json();
    return result.data as EdgeRelease[]
}

function updateEdgeERelease(id : string, body : any) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',  
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
        body: JSON.stringify(body)
    };

    return fetch(`api/v1/saas/edges/releases/` + id, requestOptions);
}

async function deleteEdgeRelease(id: string) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 
            'Content-Type': 'application/json',  
            'accept': 'application/json',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
        },
    };
    const res = await fetch(`api/v1/saas/edges/releases/` + id, requestOptions);
    return res.status;
}
